'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import c from "./top-bar.module.scss.js";
import m from "../../external/classnames/index.js";
import { useRef as h, useCallback as u, useEffect as d, useState as p } from "react";
import v from "../../styles/maps.json.js";
const y = ({ variant: r = "primary", onResize: n, items: a }) => {
  const t = h(null), i = u(() => {
    var e, o;
    (e = t.current) != null && e.clientHeight && ((o = document.querySelector("html")) == null || o.style.setProperty(
      "--top-bar-height",
      t.current.clientHeight + "px"
    ), n == null || n(t.current.clientHeight));
  }, [n]);
  d(() => (i(), window.addEventListener("resize", () => {
    i();
  }), () => {
    window.removeEventListener("resize", () => {
      i();
    });
  }), [i]);
  const l = a ?? [];
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      className: c["top-bar"],
      "data-variant": r,
      children: /* @__PURE__ */ s.jsx(w, { items: l })
    }
  );
}, f = (r) => parseInt(r.split("px")[0]), w = ({ items: r }) => {
  const [n, a] = p(0), [t, i] = p(0), l = n < f(v.breakpoints.md) ? r.filter(
    (e) => e.screen === "sm" || e.screen === "all"
  ) : r.filter(
    (e) => e.screen === "md" || e.screen === "all"
  );
  return d(() => (a(window.innerWidth), window.addEventListener("resize", () => {
    a(window.innerWidth);
  }), () => {
    window.removeEventListener("resize", () => {
      a(window.innerWidth);
    });
  }), []), d(() => {
    const e = setInterval(() => {
      t + 1 < l.length ? i(t + 1) : i(0);
    }, 4e3);
    return () => clearInterval(e);
  }, [t, l.length]), /* @__PURE__ */ s.jsx(s.Fragment, { children: l.map((e, o) => /* @__PURE__ */ s.jsx(x, { item: e, active: t === o }, o)) });
}, x = ({ item: r, active: n }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: m(c["top-bar--items--item"], {
      [c.active]: n
    }),
    children: /* @__PURE__ */ s.jsx("div", { className: m(c["top-bar--items--item-label"]), children: r.content })
  }
);
export {
  y as default
};
